<template>
  <div>
    <v-data-table :items="sessions" hide-actions v-bind:headers="headers">
      <template slot="items" slot-scope="props">
        <td>{{props.item.ip_address}}</td>
        <td>{{props.item.user_agent.name}} {{props.item.user_agent.version}}</td>
        <td>{{formatTimestamp(props.item.created_at)}}</td>
        <td>{{formatTimestamp(props.item.online_at)}}</td>
        <td class="text-xs-right"><v-btn dark class="red" v-show="!props.item.current" @click="deleteSession(props.item)">Delete</v-btn></td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import date from "../../lib/date"
import moment from "moment"
import {UAParser} from "ua-parser-js"
export default {

  data () {
    return {
      headers: [
        {text: "IP-address", "align": "left", "value": "ip_address"},
        {text: "Browser", "align": "left", "value": "user_agent"},
        {text: "Login time", "align": "left", "value": "created_at"},
        {text: "Online at", "align": "left", "value": "online_at"},
        {text: "Actions", "align": "right", sortable: false}
      ]
    }
  },
  computed: {
    sessions () {
      return this.$store.state.sessions.map((session) => {
        var online_at = (session.current) ? moment().unix() : this.$store.getters.get_session_online_at(session.id);
        var parser = UAParser(session.meta.user_agent);
        return {
          id: session.id,
          current: session.current,
          ip_address: session.meta.ip,
          user_agent: (parser ? parser.browser : session.meta.user_agent),
          created_at: session.inserted_at,
          online_at: online_at
        }
      });
    }
  },
  created () {
    this.get_profile()
  },
  methods: {
    get_profile () {
      this.$store.dispatch("get_profile")
    },
    formatTimestamp (val) {
      if(val == 0) return "Long time ago";
      return date.format_date(val) + " " + date.format_time(val)
    },
    deleteSession (session) {
      this.$http.post("session/delete/"+session.id).then((response) => {
        if(response.body.status == "ok") {
          this.$message.success("Session has been deleted!")
          this.get_profile()
        } else {
          this.$message.warning("Unable to delete session!")
        }
      }, (response) => {
        this.$message.warning("Unable to delete session!")
      })
    }
  }

}
</script>
